export enum VerificationType {
  Sms = 1,
  Email = 2,
  SmsAndEmail = 3,
  Manual = 4,
}
